import { post } from "../utils/backend";
import { EnterpriseAccount, ChangeRecord, FinishWithdrawParams, ChargeParams, CashbackParams, EnterpriseAccountFilter, RegisterWithdrawParams } from "../models/EnterpriseAccount";
import { getMockData, mock } from "./mock/Mock";
import "./mock/EnterpriseAccountMock";

const getEnterpriseAccountList = async (filter: EnterpriseAccountFilter): Promise<EnterpriseAccount[]> => {
    if (mock) {
        const accounts = getMockData("ENTERPRISE_ACCOUNTS") as EnterpriseAccount[];
        if (filter.searchText) {
            const searchText = filter.searchText.toLowerCase();
            return accounts.filter(account => 
                account.sellerId.toString().includes(searchText) ||
                account.sellerPhone.includes(searchText) ||
                account.enterpriseName.toLowerCase().includes(searchText) ||
                account.taxNo.toLowerCase().includes(searchText)
            );
        }
        return accounts;
    }
    const resultOrErrorCode = await post<EnterpriseAccountFilter, EnterpriseAccount[]>("/management/enterpriseAccount/getEnterpriseAccountList", filter);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getChangeRecordsByEnterprise = async (sellerId: number): Promise<ChangeRecord[]> => {
    if (mock) {
        const records = getMockData("CHANGE_RECORDS") as Record<number, ChangeRecord[]>;
        return records[sellerId] || [];
    }
    const resultOrErrorCode = await post<number, ChangeRecord[]>("/management/enterpriseAccount/getChangeRecordsByEnterprise", sellerId);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const charge = async (params: ChargeParams): Promise<number> => {
    if (mock) {
        return 1001;
    }
    const resultOrErrorCode = await post<ChargeParams, number>("/management/enterpriseAccount/charge", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return -1;
    }
    return resultOrErrorCode;
};

const cashback = async (params: CashbackParams): Promise<number> => {
    if (mock) {
        return 1002;
    }
    const resultOrErrorCode = await post<CashbackParams, number>("/management/enterpriseAccount/cashback", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return -1;
    }
    return resultOrErrorCode;
};

const registerWithdraw = async (params: RegisterWithdrawParams): Promise<number> => {
    if (mock) {
        return 1003;
    }
    const resultOrErrorCode = await post<RegisterWithdrawParams, number>("/management/enterpriseAccount/registerWithdraw", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return -1;
    }
    return resultOrErrorCode;
};

const finishWithdraw = async (params: FinishWithdrawParams): Promise<number> => {
    if (mock) {
        return 1000;
    }
    const resultOrErrorCode = await post<FinishWithdrawParams, number>("/management/enterpriseAccount/finishWithdraw", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return -1;
    }
    return resultOrErrorCode;
};

export const EnterpriseAccountApi = {
    getEnterpriseAccountList,
    getChangeRecordsByEnterprise,
    registerWithdraw,
    finishWithdraw,
    charge,
    cashback
}; 